// Libraries
import {
    memo, useContext, useEffect, useMemo, 
    useState
} from 'react';
import {
    useTheme 
} from '@mui/material';

// Utils
import {
    createGoalsSkip, createPhoneSkip
} from '../../config/utils';

// Config
import {
    DiagnosticFormContext 
} from '../../../../contexts/form';
import {
    useCookies 
} from 'react-cookie';

// Components
import SCREENS from './sections';

// v2 of new diagnostic
// removed intro animation
// updated drink baselines screen
// joint information capture
// removed phone permission screen
// shortened the plan section
// joint premium checkout

type Props = {
    index: number;
};

export default memo(function DiagnosticForm20250220({
    index = 0 
}: Props) {
    const diagnosticFormContext = useContext(DiagnosticFormContext);
    const theme = useTheme();
    const [cookies] = useCookies();
    const [isLoading, setIsLoading] = useState(true);
    const skippySkipsGoals = useMemo(() => createGoalsSkip(diagnosticFormContext, 33), [diagnosticFormContext]);
    const skippySkipsPhone = useMemo(() => createPhoneSkip(diagnosticFormContext, 11), [diagnosticFormContext]);

    // Set initial values and functions in context
    useEffect(() => {
        diagnosticFormContext.skippySkipsGoals = skippySkipsGoals;
        diagnosticFormContext.skippySkipsPhone = skippySkipsPhone;

        const checkoutSection = diagnosticFormContext.sections.find(s => s.key === 'checkout');
        checkoutSection.colors = {
            ...checkoutSection.colors,
            ctaBackground: theme.palette.success.light,
            ctaButton: theme.palette.success.main,
        };
        diagnosticFormContext.sections[0].length = 7;
        diagnosticFormContext.sections[1].length = 18;
        diagnosticFormContext.sections[2].length = 5;
        diagnosticFormContext.sections[3].length = 22;
        setIsLoading(false);
    }, []);

    useEffect(() => {
        const trackingName = screens[index].trackingName;
        const screenName = screens[index].screenName;

        if (trackingName) diagnosticFormContext.fireTrackingEvents(diagnosticFormContext, trackingName, cookies);
        if (screenName) diagnosticFormContext.currentScreenName = screenName;
    }, [index]);

    const screens = useMemo(() => ([
        ...SCREENS.GOALS_SCREENS,
        ...SCREENS.HABITS_SCREENS_V4,
        ...SCREENS.ABOUT_YOU_SCREENS_V2,
        ...SCREENS.PLAN_SCREENS_V3,
        ...SCREENS.CHECKOUT_SCREENS_V3
    ]), []);
    
    if (isLoading) return <></>;

    return (
        <>
            {screens[index].component}
        </>
    );
});
